/**
 * String Manipulation plugin 
 * @type {{install(*, *): void}}
 */
const StrPlugin = {

    install(app, options) {

        /**
         * Trim string
         */
        app.config.globalProperties.$trim = (text, max = 35, appendText = '...', first=false) => {

            if (text === null || text === undefined) {
                return '';
            }

            text = String(text);

            if (text.length > max) {
                let txt = first ? text.split(' ')[0] : text;
                return `${txt.substr(0, max)} ${appendText}`;
            }

            return text;
        }
    }
}

export default StrPlugin;